module.exports = __webpack_public_path__ + "static/img/wave.ad7ee3be.png";